import { render } from "./TextareaAutoResize.vue?vue&type=template&id=0cdfa86c&scoped=true"
import script from "./TextareaAutoResize.vue?vue&type=script&lang=js"
export * from "./TextareaAutoResize.vue?vue&type=script&lang=js"

import "./TextareaAutoResize.vue?vue&type=style&index=0&id=0cdfa86c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cdfa86c"

export default script